/** Dopo apertura modale: ignora tap/click fantasma (iOS PWA cold start). */
export const MODAL_TAP_GUARD_MS = 900;

export function isWithinModalTapGuard(guardUntilMs) {
  return typeof guardUntilMs === 'number' && Date.now() < guardUntilMs;
}

/** Segnala che un modale video/documento è aperto (Header, ecc.). */
export function setMediaModalOpen(open) {
  if (typeof document === 'undefined') return;
  if (open) {
    document.body.dataset.mtcMediaOpen = '1';
  } else {
    delete document.body.dataset.mtcMediaOpen;
  }
}

export function isMediaModalOpen() {
  return typeof document !== 'undefined' && document.body.dataset.mtcMediaOpen === '1';
}

/** Touch / PWA: evitare chiusura accidentale tap sul backdrop. */
export function shouldUseBackdropDismiss() {
  // Fail-safe: in PWA mobile abbiamo click/tap "fantasma" sul primo open.
  // Chiusura solo da pulsante X evita regressioni finché non isoliamo il trigger.
  return false;
}
